import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "ota-upgrade" }
const _hoisted_2 = { class: "search-bar" }
const _hoisted_3 = { class: "table-bar" }
const _hoisted_4 = { class: "table-tools" }
const _hoisted_5 = { class: "search-bar" }
const _hoisted_6 = { class: "table-bar" }
const _hoisted_7 = { class: "table-tools" }

import { ref } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'OtaUpgrade',
  setup(__props) {

const tabKey = ref('list')
const columns = [
  { title: '升级包名称', dataIndex: 'name', key: 'name' },
  { title: '升级包版本号', dataIndex: 'version', key: 'version' },
  { title: '所属产品', dataIndex: 'product', key: 'product' },
  { title: '状态', dataIndex: 'status', key: 'status' },
  { title: '创建时间', dataIndex: 'createdAt', key: 'createdAt' },
  { title: '操作', dataIndex: 'action', key: 'action' }
]
const moduleColumns = [
  { title: '模块名称', dataIndex: 'name', key: 'name' },
  { title: '所属产品', dataIndex: 'product', key: 'product' },
  { title: '模块编码', dataIndex: 'code', key: 'code' },
  { title: '模块描述', dataIndex: 'desc', key: 'desc' },
  { title: '操作', dataIndex: 'action', key: 'action' }
]

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_a_empty = _resolveComponent("a-empty")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_card, null, {
      default: _withCtx(() => [
        _createVNode(_component_a_tabs, {
          activeKey: tabKey.value,
          "onUpdate:activeKey": _cache[0] || (_cache[0] = ($event: any) => ((tabKey).value = $event))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_tab_pane, {
              key: "list",
              tab: "升级包列表"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(_component_a_form, { layout: "inline" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_form_item, { label: "产品" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_input, {
                            style: {"width":"180px"},
                            placeholder: ""
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_form_item, { label: "升级包名称" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_input, {
                            style: {"width":"180px"},
                            placeholder: "请输入升级包名称"
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_form_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_button, { type: "primary" }, {
                            default: _withCtx(() => _cache[1] || (_cache[1] = [
                              _createTextVNode("查询")
                            ])),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_form_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_button, null, {
                            default: _withCtx(() => _cache[2] || (_cache[2] = [
                              _createTextVNode("重置")
                            ])),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_component_a_button, { type: "primary" }, {
                    default: _withCtx(() => _cache[3] || (_cache[3] = [
                      _createTextVNode("新增")
                    ])),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_4, [
                    _createVNode(_component_a_button, { type: "text" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-rotate-right" })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_button, { type: "text" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-table-cells-large" })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_button, { type: "text" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-arrows-up-to-line" })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_button, { type: "text" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-gear" })
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createVNode(_component_a_table, {
                  columns: columns,
                  "data-source": [],
                  pagination: false,
                  style: {"margin-top":"16px"}
                }, {
                  emptyText: _withCtx(() => [
                    _createVNode(_component_a_empty, { description: "暂无数据" })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_a_tab_pane, {
              key: "module",
              tab: "模块列表"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_a_form, { layout: "inline" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_form_item, { label: "模块名称" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_input, {
                            style: {"width":"180px"},
                            placeholder: "请输入模块名称"
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_form_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_button, { type: "primary" }, {
                            default: _withCtx(() => _cache[4] || (_cache[4] = [
                              _createTextVNode("查询")
                            ])),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_form_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_button, null, {
                            default: _withCtx(() => _cache[5] || (_cache[5] = [
                              _createTextVNode("重置")
                            ])),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_a_button, { type: "primary" }, {
                    default: _withCtx(() => _cache[6] || (_cache[6] = [
                      _createTextVNode("新增")
                    ])),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(_component_a_button, { type: "text" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-rotate-right" })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_button, { type: "text" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-table-cells-large" })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_button, { type: "text" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-arrows-up-to-line" })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_button, { type: "text" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-gear" })
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createVNode(_component_a_table, {
                  columns: moduleColumns,
                  "data-source": [],
                  pagination: false,
                  style: {"margin-top":"16px"}
                }, {
                  emptyText: _withCtx(() => [
                    _createVNode(_component_a_empty, { description: "暂无数据" })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["activeKey"])
      ]),
      _: 1
    })
  ]))
}
}

})